import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

export const SEO = ({
  title = "NexFLY Immigration Consultancy",
  description = "Your trusted partner for immigration, study abroad, work permits, PR, and language coaching services. Making global dreams accessible.",
  keywords = "immigration consultancy, visa services, study abroad, work permit, permanent residency, IELTS coaching, German language, Coimbatore",
  image = "/nexfly-logo.png",
  url = "",
  type = "website"
}) => {
  const siteName = "NexFLY Immigration Consultancy";
  // Ensure title is never empty - fallback to siteName if empty/null/undefined
  const safeTitle = (title && String(title).trim()) ? String(title) : siteName;
  const fullTitle = safeTitle === siteName ? safeTitle : `${safeTitle} | ${siteName}`;
  
  // Ensure fullTitle is always a non-empty string
  const finalTitle = fullTitle || siteName;
  
  // Set document title directly as a fallback
  useEffect(() => {
    document.title = finalTitle;
  }, [finalTitle]);

  // Only render meta tags, not title (to avoid Helmet error)
  return (
    <Helmet>
      <meta name="title" content={finalTitle} />
      <meta name="description" content={description || ""} />
      <meta name="keywords" content={keywords || ""} />

      <meta property="og:type" content={type || "website"} />
      <meta property="og:url" content={url || ""} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:image" content={image || ""} />
      <meta property="og:site_name" content={siteName} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url || ""} />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={description || ""} />
      <meta property="twitter:image" content={image || ""} />

      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="NexFLY Immigration Consultancy" />
      {url && <link rel="canonical" href={url} />}
    </Helmet>
  );
};
